import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DragSource } from 'react-dnd'
import ItemTypes from './ItemTypes'
import PeriodicalIteam from 'shared/components/PeriodicalIteam/index';
import * as FontAwesome from 'react-icons/lib/fa';


const PeriodicalListSource = 
{
	beginDrag(props) {
		return {
			name: props.name,
			id:props.id,
			is_charged:props.is_charged,
			periodical_id:props.periodical_id,
			icon:props.icon
		}
	},
	endDrag(props, monitor) {
		const item = monitor.getItem()
		const dropResult = monitor.getDropResult()
		if (dropResult) 
		{
			
		}
	},
}

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging(),
	};
  }

const propTypes = {
	connectDragSource: PropTypes.func.isRequired,
	isDragging: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	isDropped: PropTypes.bool,
	is_separately_charge:PropTypes.number,
	
  };
class PeriodicalIteams extends Component {

	render() {
		const { id,name, isDropped, isDragging, connectDragSource,type,is_separately_charge} = this.props
		const opacity = isDragging ? 0 : 1
		return connectDragSource(
			<div id={id} style={{ opacity, width: '100%' }}>
			   <PeriodicalIteam id={id} icon={this.props.icon} enable={this.props.enable} deleteClick={this.props.deleteClick} onpClick={this.props.onpClick}  font_icon={<FontAwesome.FaArrows/>}  name={name} type={type} is_separately_charge={is_separately_charge} >{name}</PeriodicalIteam>
			</div>
		)
	}
}
PeriodicalIteams.propTypes = propTypes;
export default DragSource(ItemTypes.BOX,PeriodicalListSource, collect)(PeriodicalIteams);


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalConfig/periodical_iteam.js